package com.cybergstudios.rtc.world

import com.cybergstudios.rtc.math.Vec2

data class Rectangle(val topLeft: Vec2, val bottomRight: Vec2) {
    fun scale(v: Double): Rectangle = Rectangle(topLeft.scale(v), bottomRight.scale(v))
    fun add(v: Vec2): Rectangle = Rectangle(topLeft.add(v), bottomRight.add(v))
}